/** The `sidebar.*` translation key the credits row shows once the balance is used up. */
export type EmptyCreditsLabelKey = "reactivateAccount" | "skipTrial" | "noCredits";

interface EmptyCreditsLabelInput {
	/** The subscription is cancelled but access has not ended yet (`getCancellationInfo` ≠ null). */
	isCancellationPending: boolean;
	/** A self-registered company still in its trial (`perMonthOrYear` is "demo"). */
	isDemo: boolean;
}

/**
 * Which sentence the left nav's empty-credits row shows (PREC-4101).
 *
 * A company that cancelled but can still use Signalist is offered its way back, not "Skip Trial":
 * the row links to Company Settings → Billing, which shows the "Reactivate Subscription" button in
 * exactly that state. Whether its remaining credits return on reactivation is deliberately not
 * promised here.
 */
export const resolveEmptyCreditsLabelKey = ({
	isCancellationPending,
	isDemo,
}: EmptyCreditsLabelInput): EmptyCreditsLabelKey => {
	if (isCancellationPending) {
		return "reactivateAccount";
	}

	return isDemo ? "skipTrial" : "noCredits";
};
